import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=2767a718&scoped=true"
import script from "./main-footer.vue?vue&type=script&lang=js"
export * from "./main-footer.vue?vue&type=script&lang=js"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=2767a718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2767a718",
  null
  
)

export default component.exports